export class RouteCollection {
  constructor(incomingRoutes) {
    this.routes = void 0;
    this.routes = incomingRoutes;
  }
  findMatch(url) {
    return Object.entries(this.routes).find(_ref => {
      let [view, matcher] = _ref;
      return matcher.matches(url);
    });
  }
  getUrlForView(viewName) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const matcher = this.routes[viewName];
    if (matcher === undefined) {
      throw new Error(`View '${viewName} Does not exist}`);
    }
    return matcher.getUrl(args);
  }
  getViewForUrl(url) {
    const [view] = this.findMatch(url) || [undefined];
    return view || '';
  }
  getArgsForView(url) {
    const view = this.getViewForUrl(url);
    if (!view || view.length === 0) {
      return {};
    }
    const matcher = this.routes[view];
    return matcher.getArgs(url);
  }
}
//# sourceMappingURL=RouteCollection.js.map